import api from '../api';

/**
 * Requests a refund for an order.
 *
 * @param {string} orderId - The ID of the order to refund.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const refundOrder = async (orderId) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/order/refund`;
  const requestData = {
    "orderId": orderId,


  };
  try {

    const response = await api.post(endpoint, requestData );
    console.log(response)
    return response.data;
  } catch (error) {
    
    console.error('Error processing refund:', error);
    throw error;
  }
}

export default refundOrder;
